// DO NOT EDIT -- generated from fs/services/orgs/recording.proto

import * as fullstory_settings_recording_v1 from '../../api/fullstoryapis/settings/recording/v1alpha';
import * as protobuf from '../../../google/protobuf';

export interface WebRecordingSettings {
  /** True if web recording is enabled */
  recordingEnabled: boolean;
  consoleWatcherEnabled: boolean;
  ajaxWatcherEnabled: boolean;
  onlyRecordKnownDomains: boolean;
  domains: KnownDomain[];
  watches: ElementWatch[];
  recordGeoMode: GeoRecordMode;
  recordGeoZones: string[];
  blockedIps: string[];
  blockedUas: string[];
  blockedAppIds: string[];
  resourceUploadingEnabled: boolean;
}

export interface WebRecordingSettingsUpdate {
  orgId: string;
  recordingEnabled: boolean | null;
  consoleWatcherEnabled: boolean | null;
  ajaxWatcherEnabled: boolean | null;
  onlyRecordKnownDomains: boolean | null;
  domains: DomainUpdate[];
  watches: WatchUpdate[];
  geoMode: WebRecordingSettingsUpdate.GeoModeUpdate | null;
  geoZones: ListUpdate | null;
  blockedIps: ListUpdate | null;
  blockedUas: ListUpdate | null;
  blockedAppIds: ListUpdate | null;
  resourceUploadingEnabled: boolean | null;
}

export namespace WebRecordingSettingsUpdate {
  export interface GeoModeUpdate {
    value: GeoRecordMode;
  }
}

export interface WatchUpdate {
  namedElementId: string;
  /** @deprecated */
  selector: string;
  action: UpdateAction;
  /**
   * May be present when adding or updating a watch. Ignored for delete actions and named elements.
   * Named elements will have their name and description in search-settings.
   * 
   * @deprecated
   */
  label: string;
  /** @deprecated */
  notes: string;
}

export interface MobileRecordingSettings {
  recordingEnabled: boolean;
  domains: KnownDomain[];
  sessionTargetingRules: TargetingRule[];
  consoleWatcherEnabled: boolean;
  ajaxWatcherEnabled: boolean;
  mobileImageUnmaskMode: AutomaticImageUnmaskMode;
}

export interface MobileRecordingSettingsUpdate {
  orgId: string;
  recordingEnabled: boolean | null;
  domains: DomainUpdate[];
  sessionTargetingRules: TargetingRuleUpdate[];
  consoleWatcherEnabled: boolean | null;
  ajaxWatcherEnabled: boolean | null;
  mobileImageUnmaskMode: AutomaticImageUnmaskMode;
}

export interface PrivacySettings {
  elementBlocks: ElementBlock[];
  ajaxWatches: AjaxWatch[];
  discardIpAddresses: boolean;
  urlPrivacyRules: fullstory_settings_recording_v1.UrlPrivacyRule[];
}

/** Defines the different automatic image unmasking modes */
export enum AutomaticImageUnmaskMode {
  /** invalid option, never match */
  UNMASK_MODE_UNSET = 0,
  /** automatic unmasking disabled */
  UNMASK_MODE_OFF = 1,
  /** automatic image unmasking for built-in assets */
  UNMASK_MODE_ASSETS = 2
}

/**
 * This is a PrivacySettings message with an additional field that's only
 * available via ingestion-settings. It's here temporarily for compatibility, so
 * that we can return this information from /settings/privacy without requiring
 * any substantial changes to the client code that might introduce risk
 * immediately prior to the Black Friday 2020 code freeze. We want to replace
 * this as soon as is feasible with a new endpoint that returns the
 * ingestion-settings version of PrivacySettings. At that point we can retire
 * the existing /settings/privacy endpoint.
 */
export interface PrivacySettingsResponse {
  elementBlocks: ElementBlock[];
  ajaxWatches: AjaxWatch[];
  discardIpAddresses: boolean;
  /**
   * True if this org's DefaultPrivacyMode is something other than
   * PRIVACY_MODE_OFF.
   */
  privateByDefault: boolean;
  urlPrivacyRules: fullstory_settings_recording_v1.UrlPrivacyRule[];
  /** Element Privacy rule groups for this org. */
  elementRuleGroups: { [key: string]: fullstory_settings_recording_v1.ElementPrivacyRuleGroup };
}

export interface PrivacySettingsUpdate {
  orgId: string;
  blocks: BlockUpdate[];
  updateAjaxWatches: AjaxWatchUpdate[];
  discardIpAddresses: boolean | null;
}

export interface PrivacySettingsUpdateResponse {
  /** Selectors with new "last_update" time. */
  updatedSelectors: string[];
  /** The new value of "last_update" for those selectors. */
  updateTime: protobuf.timestamp | null;
}

export enum BlockType {
  UNSET = 0,
  BLOCK_EXCLUDE = 1,
  BLOCK_MASK = 2,
  BLOCK_UNMASK = 3
}

/**
 * RuleScope is used to limit the scope exclusion rules
 * so a customer can dogfood a rule in "audited" sessions they record
 * themselves before turning the rule on for all of their users.
 */
export enum RuleScope {
  /** Apply always (default). */
  ALL_SESSIONS = 0,
  /** Never apply. */
  NO_SESSIONS = 1,
  /** Apply only for "previewed" sessions e.g. to test the addition of a BLOCK_UNMASK rule. */
  PREVIEW_SESSIONS_ONLY = 2,
  /** Apply only for non-preview sessions e.g. to test the removal of an BLOCK_EXCLUDE rule. */
  LIVE_SESSIONS_ONLY = 3
}

/** @deprecated */
export interface ElementBlock {
  selector: string;
  consent: boolean;
  notes: string;
  type: BlockType;
  scope: RuleScope;
  lastUpdated: protobuf.timestamp | null;
  label: string;
  targetingConditions: TargetingRuleCondition[];
  exceptionSelectors: string[];
  groupId: number;
}

export interface ElementWatch {
  /** id referencing the named element that contains the selector, name, and description in search-settings */
  namedElementId: string;
  /**
   * held in search-settings moving forward
   * 
   * @deprecated
   */
  selector: string;
  /**
   * held in search-settings moving forward
   * 
   * @deprecated
   */
  label: string;
  /**
   * held in search-settings moving forward
   * 
   * @deprecated
   */
  notes: string;
  lastUpdated: protobuf.timestamp | null;
}

/** @deprecated */
export interface BlockUpdate {
  /** Nil if action is DELETE */
  block: ElementBlock | null;
  /** Nil if action is ADD */
  previousSelector: string;
  action: UpdateAction;
}

export interface AjaxWatch {
  urlRegex: string;
  recordReq: RecordAjaxBody;
  recordRsp: RecordAjaxBody;
  whitelistReq: string;
  whitelistRsp: string;
}

export interface AjaxWatchUpdate {
  watch: AjaxWatch | null;
  action: UpdateAction;
  previousUrlRegexp: string;
}

export enum RecordAjaxBody {
  ELIDE = 0,
  RECORD = 1,
  WHITELIST = 2
}

export interface KnownDomain {
  disabled: boolean;
  domain: string;
}

export interface DomainUpdate {
  domain: string;
  action: UpdateAction;
  /** Set the state, not used when action is DELETE */
  disabled: boolean;
}

export enum GeoRecordMode {
  GEO_ALL = 0,
  GEO_WHITELIST = 1,
  GEO_BLACKLIST = 2
}

/** Generic way to update items in a list of strings by adding and/or deleting. */
export interface ListUpdate {
  adds: string[];
  deletes: string[];
}

/** Generic action for updating items in a collection. */
export enum UpdateAction {
  ADD = 0,
  UPDATE = 1,
  DELETE = 2
}

/** Attributes of the session compared against in a TargetingRuleCondition */
export enum TargetingRuleAttribute {
  TGT_RULE_ATTR_INVALID = 0,
  /**
   * common
   * identified user
   */
  UID = 1,
  IP = 2,
  LOCATION = 3,
  /** a value of schema.PageTypeEnum */
  PLATFORM = 13,
  /** web related */
  DOMAIN = 4,
  USER_AGENT = 5,
  /**
   * native mobile related
   * application version string (can be normalized to a numeric value for comparison operators, if in dotted quad form)
   */
  APP_VERSION = 6,
  /** application build variant */
  BUILD_TYPE = 7,
  /** application fs instrumentation version */
  FS_VERSION = 8,
  /** application fs build id */
  FS_BUILD_ID = 9,
  /** operating system version */
  OS_VERSION = 10,
  /** device model */
  MODEL = 11,
  /** device manufacturer */
  MANUFACTURER = 12
}

/** Comparison operators that we use to compare a targeting attribute’s incoming value against a declared value in a TargetingRuleCondition */
export enum TargetingRuleOperator {
  TGT_RULE_OP_INVALID = 0,
  EQ = 1,
  NEQ = 2,
  LT = 3,
  LTE = 4,
  GT = 5,
  GTE = 6,
  RANGE = 7,
  CONTAINS = 8
}

/** Represents a dotted quad version number */
export interface TargetingRuleVersionValue {
  major: protobuf.uint64;
  minor: protobuf.uint64;
  build: protobuf.uint64;
  revision: protobuf.uint64;
}

export interface TargetingRuleValue {
  strVal?: string;
  intVal?: protobuf.int64;
  versionVal?: TargetingRuleVersionValue | null;
}

export namespace TargetingRuleValue {
  export enum val {
    strVal = 1,
    intVal = 2,
    versionVal = 3
  }

  export function val_oneof(m: TargetingRuleValue): { opt: val.intVal, val: protobuf.int64 } | { opt: val.strVal, val: string } | { opt: val.versionVal, val: TargetingRuleVersionValue } | null {
    if (m.strVal != null) { return { opt: val.strVal, val: m.strVal } }
    if (m.intVal != null) { return { opt: val.intVal, val: m.intVal } }
    if (m.versionVal != null) { return { opt: val.versionVal, val: m.versionVal } }
    return null;
  }
}

export interface TargetingRuleCondition {
  attr: TargetingRuleAttribute;
  op: TargetingRuleOperator;
  values: TargetingRuleValue[];
  /** conjunction type to use for the previous condition if multiple */
  joinPrevious: TargetingRuleConjunction;
}

/** Joins multiple TargetingRuleConditions and/or TargetingRules */
export enum TargetingRuleConjunction {
  TGT_RULE_CNJ_INVALID = 0,
  AND = 1,
  OR = 2
}

/** a reference to a rule by id and a join operator for expressing composite rules */
export interface TargetingRuleChildRef {
  id: string;
  joinPrevious: TargetingRuleConjunction;
}

/**
 * TargetingRule is a collection of TargetingRuleConditions and (optionally) composed of other defined TargetingRules.
 * TargetingRules be associated with privacy rules for further specificity, or used to conditionally block sessions.
 */
export interface TargetingRule {
  /** a named identifier for this rule, which can be referenced to build a composite rule by a UI */
  id: string;
  /** additional information provided by the author */
  notes: string;
  scope: RuleScope;
  /** the set of conditions for this rule */
  conditions: TargetingRuleCondition[];
  /** for expressing composite rules */
  children: TargetingRuleChildRef[];
}

/** wrapper for a collection of targeting rule conditions. Only used for json serialization. */
export interface TargetingConditionsEnvelope {
  conditions: TargetingRuleCondition[];
}

/** wrapper for a collection of targeting rules. Only used for json serialization. */
export interface TargetingRulesEnvelope {
  rules: TargetingRule[];
}

export interface TargetingRuleUpdate {
  action: UpdateAction;
  rule: TargetingRule | null;
}
